export const GA_IDS = ["G-W68WL6LFCZ", "G-RT8LWMQEYG"];

export const trackEvent = (name, params = {}) => {
  if (typeof window.gtag !== "function") return;
  window.gtag("event", name, params);
};

export const trackPageView = (path, title) => {
  if (typeof window.gtag !== "function") return;
  const params = {
    page_path: path,
    page_location: window.location.origin + path,
    page_title: title || document.title,
  };
  GA_IDS.forEach((id) => window.gtag("event", "page_view", { ...params, send_to: id }));
};

const normalizePhone = (href) => href.replace(/^tel:/i, "").replace(/[^0-9+]/g, "");

export const classifyClick = (anchor) => {
  const href = anchor.getAttribute("href") || "";
  const cta = anchor.getAttribute("data-cta");
  if (cta) return { name: "cta_click", params: { cta_name: cta, link_url: href } };
  if (/^tel:/i.test(href)) return { name: "phone_click", params: { phone_number: normalizePhone(href) } };
  if (/wa\.me|whatsapp/i.test(href)) {
    const m = href.match(/wa\.me\/(\d+)/);
    return { name: "whatsapp_click", params: { phone_number: m ? `+${m[1]}` : "" } };
  }
  if (/^viber:/i.test(href)) {
    const m = href.match(/number=(?:%2B|\+)?(\d+)/);
    return { name: "viber_click", params: { phone_number: m ? `+${m[1]}` : "" } };
  }
  return null;
};
